import React from 'react';

import IconMagnifier from '../icons/IconMagnifier';
import BaseAutocomplete from '../BaseAutocomplete';

import './index.css';

const AutocompleteSearchBar = (props) => {

  return (
    <div className={`${props.className} search-bar`}>
      <span className="search-bar__icon"><IconMagnifier/></span>
      <BaseAutocomplete 
        className="search-bar__input-wrapper" 
        selectClassName="search-bar__input"
        optionsListWidth="100%"
        inputPlaceholder={props.inputPlaceholder}
        inputButtonPlaceholder={props.inputButtonPlaceholder}
        type="select" 
        selectOptions={props.selectOptions} 
        selectOption={props.selectOption} 
        value={props.value}
        inputId="dealer"
        getText={props.getText}
      />
    </div>
  );
}

export default AutocompleteSearchBar;